module.exports = __webpack_public_path__ + "static/img/undefined.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/undefined.jpg
// module id = 7i7r
// module chunks = 0